export default __webpack_public_path__ + "static/media/games-active-m.6e40ff92.svg";